export default __webpack_public_path__ + "img/b638c6cd18f5132440ac9a727a873753.svg";